import React from "react";
import type { ReactNode } from "react";
import { s } from "../styles";

interface TextBoxProps {
  label: ReactNode;
  num: string;
  value: string | number | null | undefined;
  flex?: number;
}

export default function TextBox({ label, num, value, flex }: TextBoxProps) {
  return (
    <div style={{ ...s.mbox, flex: flex || 1 }}>
      <div style={s.mlabel}>{label}</div>
      <div style={s.mfield}>
        <span style={s.mnum}>{num}</span>
        <span style={s.tval}>{value || ""}</span>
      </div>
    </div>
  );
}